<template>
  <div class="pt-[50px] sm:pt-[80px]">
    <div
      class="flex-col sm:flex-row items-center flex flex-wrap justify-center  sm:space-x-20"
    >
      <div class="" v-for="(item, x) in centralbar" :key="x">
        <MenuButton
          @onPress="to(item)"
          :label="item.menu_name"
          :src="item.icon"
          :size="item.size"
        />
      </div>
    </div>
    <v-dialog
      v-model="alertDialog"
      persistent
      :overlay="false"
      max-width="280px"
      transition="dialog-transition"
    >
      <div class="bg-white p-4">
        <div class="font-bold text-center text-xl py-4">
          Under Construction
        </div>
        <div class="my-4">
          <v-btn class="w-full" text @click="alertDialog = false">Ok</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// import axios from "axios";
import MenuButton from "../../common/MenuButton.vue";

export default {
  data() {
    return {
      alertDialog: false,
      centralbar: [
        {
          id: 81,
          arrange: 1,
          path: "request-inquiry",
          menu_name: "Request/Inquiry",
          parent_id: -1,
          location: 2,
          icon: "/icons/dashboard/request-inquiry.png",
          reg_date: "2022-09-03T11:35:14.000Z",
          active: 1,
          service_type: "1",
          size: "w-[150px] h-[120px]",
        },
        {
          id: 13,
          arrange: 2,
          path: "payment-portal",
          menu_name: "Payment Portal",
          parent_id: -1,
          location: 2,
          icon: "/icons/dashboard/payment.png",
          reg_date: "2022-09-03T11:21:05.000Z",
          active: 1,
          service_type: null,
          size: "w-[150px] h-[120px]",
        },
        {
          id: 15,
          arrange: 3,
          path: "book_appointment-portal",
          menu_name: "Book an Appointment",
          parent_id: -1,
          location: 2,
          icon: "/icons/dashboard/calendar.png",
          reg_date: "2022-09-03T11:21:05.000Z",
          active: 1,
          service_type: null,
          size: "w-[110px] h-[120px]",
        },
        {
          id: 10,
          arrange: 4,
          path: "buyers-guide",
          menu_name: "Buyers Guide",
          parent_id: -1,
          location: 2,
          icon: "/icons/dashboard/guide.png",
          reg_date: "2022-11-07T05:02:55.000Z",
          active: 1,
          service_type: null,
          size: "w-[800px] h-[800px] mb-2 ml-10 ",
        },
      ],
    };
  },
  components: { MenuButton },

  methods: {
    to(item) {
      // central menus
      if (item.location != 1) {
        if (
          item.menu_name == "Request/Inquiry" ||
          item.menu_name == "Payment Portal" ||
          item.menu_name == "Book an Appointment"
        ) {
          this.alertDialog = true;
        } else {
          // this.$router.push({ name: item.menu_name });
          if (item.menu_name == "Buyers Guide") {
            this.$router.push({
              // path: "/buyers-guide-front-page",
              name: "Buyers Guide Front Page",
              query: {
                cn: this.$route.query.cn,
                cc: this.$route.query.cc,
              },
            });
          }
        }
      } else {
        // sidebar menus
        if (!this.$route.path.includes(item.route)) {
          this.$router.push({
            name: item.name,
            query: {
              cn: this.$route.query.cn,
              cc: this.$route.query.cc,
            },
          });
        }
      }
    },
  },
};
</script>
